import * as React from 'react';
import { SVGProps } from 'react';

export const OnlineCart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.6772 27.2823C9.16242 27.2823 7.9354 26.0475 7.9354 24.523C7.9354 22.9984 9.16242 21.7637 10.6772 21.7637C12.1922 21.7637 13.4192 22.9984 13.4192 24.523C13.4192 26.0475 12.1922 27.2823 10.6772 27.2823ZM10.6772 22.8674C9.77252 22.8674 9.03209 23.6124 9.03209 24.523C9.03209 25.4335 9.77252 26.1787 10.6772 26.1787C11.5821 26.1787 12.3224 25.4335 12.3224 24.523C12.3224 23.6124 11.5821 22.8674 10.6772 22.8674Z"
      fill="#071114"
    />
    <path
      d="M9.25158 19.0042H16.1611V20.1081H9.25158V19.0042Z"
      fill="#071114"
    />
    <path d="M12.8708 23.9711H16.1611V25.075H12.8708V23.9711Z" fill="#071114" />
    <path
      d="M25.4698 16.8106L24.3935 16.5829L26.0662 8.5188H7.41447V7.41492H27.4165L25.4698 16.8106Z"
      fill="#071114"
    />
    <path
      d="M18.3546 28.6138V13.2579L29 23.9711H22.9677L18.3546 28.6138ZM19.4513 15.9208V25.9509L22.5155 22.8674H26.354L19.4513 15.9208Z"
      fill="#071114"
    />
    <path
      d="M24.5719 29L22.2411 23.6401L23.242 23.1985L25.5726 28.5586L24.5719 29Z"
      fill="#071114"
    />
    <path
      d="M9.17607 22.6259L6.2491 4.10368H3V3H7.18814L10.2591 22.4466L9.17607 22.6259Z"
      fill="#071114"
    />
    <path
      d="M10.6772 27.2823C9.16242 27.2823 7.9354 26.0475 7.9354 24.523C7.9354 22.9984 9.16242 21.7637 10.6772 21.7637C12.1922 21.7637 13.4192 22.9984 13.4192 24.523C13.4192 26.0475 12.1922 27.2823 10.6772 27.2823ZM10.6772 22.8674C9.77252 22.8674 9.03209 23.6124 9.03209 24.523C9.03209 25.4335 9.77252 26.1787 10.6772 26.1787C11.5821 26.1787 12.3224 25.4335 12.3224 24.523C12.3224 23.6124 11.5821 22.8674 10.6772 22.8674Z"
      stroke="#071114"
      strokeWidth="0.4"
    />
    <path
      d="M9.25158 19.0042H16.1611V20.1081H9.25158V19.0042Z"
      stroke="#071114"
      strokeWidth="0.4"
    />
    <path
      d="M12.8708 23.9711H16.1611V25.075H12.8708V23.9711Z"
      stroke="#071114"
      strokeWidth="0.4"
    />
    <path
      d="M25.4698 16.8106L24.3935 16.5829L26.0662 8.5188H7.41447V7.41492H27.4165L25.4698 16.8106Z"
      stroke="#071114"
      strokeWidth="0.4"
    />
    <path
      d="M18.3546 28.6138V13.2579L29 23.9711H22.9677L18.3546 28.6138ZM19.4513 15.9208V25.9509L22.5155 22.8674H26.354L19.4513 15.9208Z"
      stroke="#071114"
      strokeWidth="0.4"
    />
    <path
      d="M24.5719 29L22.2411 23.6401L23.242 23.1985L25.5726 28.5586L24.5719 29Z"
      stroke="#071114"
      strokeWidth="0.4"
    />
    <path
      d="M9.17607 22.6259L6.2491 4.10368H3V3H7.18814L10.2591 22.4466L9.17607 22.6259Z"
      stroke="#071114"
      strokeWidth="0.4"
    />
  </svg>
);
export default OnlineCart;
